import PcMonitoring from 'quality/components/pcMonitoring/PcMonitoring'
import React, { useMemo } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'

const DistributionUnitPcMonitoringApp = () => {
    const { id } = useParams()

    const {
        distributionUnit,
        associatedSites,
    } = useSelector(store => ({
        distributionUnit: store.DistributionUnitReducer.distributionUnit,
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.distributionUnit,
        href: 'distributionUnit',
    }, {
        title: getStationTitle(distributionUnit),
        href: `station/distributionUnit/${id}`,
    }, {
        title: i18n.followUpPC,
        href: `station/distributionUnit/${id}/pcMonitoring`,
    }], [])

    const ids = useMemo(() => associatedSites.filter(site => site.stationLinkedType === 3).map(site => site.stationLinkedId), [associatedSites])

    return (
        <PcMonitoring
            ids={ids}
        />
    )
}

export default DistributionUnitPcMonitoringApp